import { PanelGroup } from "react-bootstrap";
import styled from "styled-components";

export const styles = {
  container: {
    border: "1px solid #dfe1e4",
    borderRadius: 5,
    margin: "20px 0",
  },
  menu: {
    borderTop: "1px solid #dfe1e4",
    margin: 0,
    padding: 0,
    listStyle: "none",
    fontWeight: "normal",
    textDecoration: "none",
    lineHeight: 1,
    position: "relative",
  },
  menuList: {
    margin: 0,
    padding: 0,
    border: 0,
    listStyle: "none",
    fontWeight: "normal",
    textDecoration: "none",
    lineHeight: 1,
    position: "relative",
  },
};

export const PageTitle = styled.h2`
  width: 100%;
  float: left;
  padding: 17px 6%;
  color: #0a3949;
  font-weight: 700;
  font-size: 16px;
  background-color: #dfe1e4;
  margin: 0;
  border-radius: 5px 5px 0 0;
  .title {
    padding-left: 1rem;
  }
`;

export const Filters = styled(PanelGroup)`
  padding-top: 52px;
  margin: 0;
  border: 0;
  .panel-heading {
    background-color: transparent;
    border: 0 !important;
    margin: 0 !important;
    border-radius: 0;
  }
  .panel {
    margin: 0 !important;
    border: 0;
    border-radius: 0;
    box-shadow: none;
  }
  .panel-default {
    margin: 0 !important;
    border-bottom: 1px solid #ddd;
    &:last-child {
      border: 0;
      border-radius: 4px;
    }
  }
  .panel-body {
    margin: 0 !important;
  }
  .panel-footer {
    border: 0 !important;
    margin: 0 !important;
  }
  a {
    text-decoration: none;
    cursor: pointer;
  }
`;

export const Header = styled.div`
  font-weight: 500;
  display: block;
  color: #184453;
  font-size: 16;
  outline: none;
  line-height: 1.3;
  i {
    padding: 3% 0;
  }
`;

export const Plus = styled.div`
  background: black;
  height: 9px;
  position: relative;
  width: 1px;

  &:after {
    background: black;
    content: "";
    height: 9px;
    left: 0px;
    position: absolute;
    top: 0px;
    width: 1px;
    transform: rotate(90deg);
  }
`;

export const Minus = styled.div`
  background: black;
  height: 9px;
  position: relative;
  width: 1px;
  transform: rotate(90deg);
  }
`;

export const SubMenu = styled.ul`
  list-style: none;
  padding: 0;
  input {
    margin: 0;
    margin-top: 2px;
    margin-right: 1rem;
  }
  label {
    font-weight: normal;
  }
  span {
    font-size: small;
  }
  .row {
    margin-top: 0.5rem;
    padding-left: 1.5rem;
    display: flex;
  }
`;
